import { Button, Inline, Notice, vars } from '@etg/wings';
import { XCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { PickAndChooseCtaState } from '../models';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getButtonLabel = (ctaState, labels) => ctaState === PickAndChooseCtaState.Select ? labels.selectPass : labels.editPass;
const mutedNoticeStyles = css`
  && {
    color: ${vars.colors.text.secondary};
  }

  && > svg {
    flex: 0 0 auto;
  }
`;
const SelectPassCta = ({
  ctaState,
  labels,
  onOpen
}) => /*#__PURE__*/_jsx("div", {
  className: "buttonWrapper",
  children: /*#__PURE__*/_jsxs(Inline, {
    align: "end",
    alignY: "center",
    spacing: 8,
    children: [ctaState === PickAndChooseCtaState.Edit && /*#__PURE__*/_jsx(Notice, {
      "data-testid": "pick-and-choose-added-passes",
      variant: "positive",
      children: labels.addedPasses
    }), ctaState === PickAndChooseCtaState.Zero && /*#__PURE__*/_jsx(Notice, {
      className: mutedNoticeStyles,
      "data-testid": "pick-and-choose-zero-passes",
      icon: /*#__PURE__*/_jsx(XCircle, {
        size: "1.25rem",
        weight: "bold"
      }),
      children: labels.zeroPasses
    }), /*#__PURE__*/_jsx(Button, {
      "data-testid": "pick-and-choose-cta",
      onClick: onOpen,
      variant: "primary",
      children: getButtonLabel(ctaState, labels)
    })]
  })
});
export default SelectPassCta;
//# sourceMappingURL=SelectPassCta.js.map